import { useQuery } from "@tanstack/react-query";
import {
  PermissionProfile,
  PersonInfo,
  Tenant,
} from "../../../types/GlobalInterfaces";
import API from "../../api/API";

const emptyArray: [] = [];

export interface UseCloud {
  cloud: TenantWithPeopleInfo;
  permissions: PermissionProfile[];
}

export interface PeopleWithInfo extends PersonInfo {
  id: string;
  Name: string;
  PrimaryContactEmail: string;
}

export interface TenantWithPeopleInfo extends Tenant {
  People: PeopleWithInfo[];
}

const useCloud = (tenantID: string | null) => {
  const cloud = useQuery({
    queryKey: ["cloud", tenantID],
    queryFn: () =>
      API.getCloudTenantByID(tenantID!).then((data) => {
        const cloud: TenantWithPeopleInfo = data.data.data.tenant;
        const permissions: PermissionProfile[] = data.data.data.profiles;

        return { cloud, permissions };
      }),
    enabled: !!tenantID,
  });

  return {
    cloud: cloud.data?.cloud,
    cloudLoading: cloud.isLoading,
    cloudError: cloud.isError,
    cloudPermissions: cloud.data?.permissions || emptyArray,
  };
};

export default useCloud;
